import { OwcChip } from "@one/react";

const getHazardousStatusStyle = (status) => {
  const normalizedStatus = status?.toString().toUpperCase();
  switch (normalizedStatus) {
    case 'APPROVED':
      return {
        color: '#007C6B',
      };
    case 'PENDING':
      return {
        color: '#FFC414',
      };
    case 'REJECTED':
      return {
        color: '#E74C3C',
      };
    default:
      return {
        color: '#6C757D',
      };
  }
};

const normalizeStatusText = (status) => {
  const normalizedStatus = status?.toString().toUpperCase();
  switch (normalizedStatus) {
    case 'APPROVED':
      return 'Approved';
    case 'PENDING':
      return 'Pending Approval';
    case 'REJECTED':
      return 'Rejected';
    default:
      // If there are hazardous materials but no approval status, default to pending
      return 'N/A';
  }
};

export const BookingHazardousChip = ({ item }) => {
  const rawStatus = item?.approval?.status;
  const hasHazardousMaterials = item?.hazardousDeclaration?.hasHazardousMaterials;
  const displayStatus = normalizeStatusText(rawStatus, hasHazardousMaterials);

  const hazardousDescription = item?.hazardousDeclaration?.hazardousMaterialsList;
  const assistanceDescription = item?.assistanceDeclaration?.assistanceReason;

  const displayHazardous = hazardousDescription ?? `Hazardous materials: ${hazardousDescription}`;
  const displayAssistence = assistanceDescription ?? `Assistance reason: ${assistanceDescription}`;
  const description = `${displayHazardous}\n${displayAssistence}`;
  const statusStyle = getHazardousStatusStyle(rawStatus);

  const tooltipContent = description ? `Hazardous materials: ${description}` : displayStatus;

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <OwcChip
        style={{
          ...statusStyle,
          fontSize: '12px',
          border: '1px solid #000',
          backgroundColor: '#fff',
          cursor: description ? 'help' : 'default',
          borderRadius: '5px',
          padding: '0px',
          minHeight: 'unset',
          fontWeight: '900',
          lineHeight: '16px',
        }}
        round
        title={tooltipContent}
      >
        {displayStatus}
      </OwcChip>
    </div>
  );
};
